import Lenis from 'lenis';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

let lenisInstance = null;
let rafHandler = null;

function initLenis() {
    if (lenisInstance) {
        lenisInstance.resize();
        return lenisInstance;
    }

    const lenis = new Lenis({
        autoRaf: false,
        lerp: 0.08,
        smoothWheel: true,
        smoothTouch: true,
        wheelMultiplier: 0.6,
        touchMultiplier: 0.7,
        anchors: true,
    });

    lenis.on('scroll', ScrollTrigger.update);

    rafHandler = (time) => {
        lenis.raf(time * 1000);
    };
    gsap.ticker.add(rafHandler);
    gsap.ticker.lagSmoothing(0);

    lenisInstance = lenis;
    window.__lenis = lenis;
    return lenisInstance;
}

function destroyLenis() {
    if (!lenisInstance) return;
    lenisInstance.destroy();
    lenisInstance = null;
    if (window.__lenis) {
        delete window.__lenis;
    }
    if (rafHandler) {
        gsap.ticker.remove(rafHandler);
        rafHandler = null;
    }
}

export { initLenis, destroyLenis };
